// @file Store to handle drag and drop events globally
import type { PostModalDropZone } from '@@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export enum DraggedDataType {
  File,
  Link,
  Text,
}

export const useSurfaceDragAndDropEventsStore = defineStore('surfaceDragAndDropEvents', () => {
  /* ---------------------- */
  /* STATE                  */
  /* ---------------------- */

  const isHandlingDragEvent = ref<boolean>(false)
  const draggedDataType = ref<DraggedDataType>(DraggedDataType.File)
  const dropActionMessage = ref<string>('')
  const postModalDropZone = ref<PostModalDropZone | null>(null)

  /* ---------------------- */
  /* ACTIONS                */
  /* ---------------------- */

  const startHandlingDragEvent = (): void => {
    isHandlingDragEvent.value = true
  }

  const stopHandlingDragEvent = (): void => {
    isHandlingDragEvent.value = false
  }

  const setDraggedDataType = (newDraggedDataType: DraggedDataType): void => {
    draggedDataType.value = newDraggedDataType
  }

  const setDropActionMessage = (newDropActionMessage: string): void => {
    dropActionMessage.value = newDropActionMessage
  }

  const setPostModalDropZone = (newPostModalDropZone): void => {
    postModalDropZone.value = newPostModalDropZone
  }

  const resetPostModalDropZone = (): void => {
    postModalDropZone.value = null
  }

  return {
    // Getters
    isHandlingDragEvent,
    draggedDataType,
    dropActionMessage,
    postModalDropZone,

    // Actions
    startHandlingDragEvent,
    stopHandlingDragEvent,
    setDraggedDataType,
    setDropActionMessage,
    setPostModalDropZone,
    resetPostModalDropZone,
  }
})
